// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BY_x","newExpiryDate":"styles_newExpiryDate__yq9iP","footer":"styles_footer__3eFFq"};